import { GridCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { SvgIcon } from '@progress/kendo-react-common';
import { reorderIcon } from '@progress/kendo-svg-icons';
import { DragContext } from '@cs-cms/state-management';

export const DragCell = (props: GridCellProps) => {
  const currentContext = React.useContext(DragContext);
  return (
    <td
      onDragOver={e => {
        currentContext.reorder(props.dataItem);
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
      }}
    >
      <span
        draggable={true}
        style={{ cursor: 'move' }}
        onDragStart={e => {
          currentContext.dragStart(props.dataItem);
          e.dataTransfer.setData('dragging', '');
        }}
      >
        <SvgIcon icon={reorderIcon} />
      </span>
    </td>
  );
};
